import request from '@/utils/request'

const getOrderCouponById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/order-coupon/${id}`,
    method: 'get'
  })
}

const getOrderCouponsByOrderId = (orderId) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/order-coupon/order-coupons-by-order-id/${orderId}`,
    method: 'get'
  })
}

export default {
  getOrderCouponById,
  getOrderCouponsByOrderId
}
